import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Lock, CreditCard } from 'lucide-react';
const includes = ['Curso grabado paso a paso', 'Acceso inmediato', 'Plantillas descargables', 'Ejemplos de anuncios', 'Checklist de campañas', 'Recursos para crear copies y hooks', 'Actualizaciones iniciales del contenido'];
export function Pricing() {
  return <section id="comprar" className="py-20 md:py-32 bg-zinc-950 relative overflow-hidden" data-id="element-173">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-[500px] bg-blue-600/20 rounded-full blur-[100px] pointer-events-none" data-id="element-174"></div>

      <div className="max-w-4xl mx-auto px-4 md:px-6 relative z-10" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-176">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white tracking-tight mb-6" data-id="element-177">
            Accedé al Sistema de Publicidad para Tiendas de iPhone
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl overflow-hidden shadow-2xl max-w-2xl mx-auto" data-id="element-178">
          <div className="p-8 md:p-12" data-id="element-179">
            <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-180">
              {/* Features */}
              <div data-id="element-181">
                <h3 className="text-lg font-bold text-zinc-900 mb-6 uppercase tracking-wider" data-id="element-182">
                  Qué incluye
                </h3>
                <ul className="space-y-4" data-id="element-183">
                  {includes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-184">
                      <CheckCircle2 className="w-5 h-5 text-blue-600 shrink-0 mt-0.5" data-id="element-185" />
                      <span className="text-zinc-700 font-medium" data-id="element-186">{item}</span>
                    </li>)}
                </ul>
              </div>

              {/* Price & CTA */}
              <div className="bg-zinc-50 p-6 md:p-8 rounded-2xl border border-zinc-200 text-center" data-id="element-187">
                <div className="text-sm font-bold text-blue-600 uppercase tracking-wider mb-2" data-id="element-188">
                  Precio lanzamiento
                </div>
                <div className="text-4xl md:text-5xl font-extrabold text-zinc-900 mb-6" data-id="element-189">
                  $24.900{' '}
                  <span className="text-xl text-zinc-500 font-medium" data-id="element-190">ARS</span>
                </div>

                <a href="https://sistema-iphone-ads.myshopify.com/products/sistema-iphone-ads" target="_blank" rel="noopener noreferrer" className="block w-full py-4 px-6 text-lg font-bold text-white bg-blue-600 rounded-xl hover:bg-blue-700 transition-colors shadow-lg hover:shadow-xl mb-4" data-id="element-191">
                  Comprar ahora
                </a>

                <div className="flex items-center justify-center gap-4 text-xs text-zinc-500" data-id="element-192">
                  <div className="flex items-center gap-1" data-id="element-193">
                    <Lock className="w-4 h-4" data-id="element-194" /> Pago seguro
                  </div>
                  <div className="flex items-center gap-1" data-id="element-195">
                    <CreditCard className="w-4 h-4" data-id="element-196" /> Acceso digital
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Anchor Copy */}
          <div className="bg-blue-600 p-4 text-center" data-id="element-197">
            <p className="text-white font-medium text-sm md:text-base" data-id="element-198">
              "Con que una campaña bien armada te ayude a vender un equipo más,
              el curso ya puede pagarse solo."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}